import { render } from "./AgentLimitedBulkActionMenu.vue?vue&type=template&id=3efc3016&scoped=true&ts=true"
import script from "./AgentLimitedBulkActionMenu.vue?vue&type=script&lang=ts"
export * from "./AgentLimitedBulkActionMenu.vue?vue&type=script&lang=ts"

import "./AgentLimitedBulkActionMenu.vue?vue&type=style&index=0&id=3efc3016&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efc3016"]])

export default __exports__
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItemSection});qInstall(script, 'directives', {ClosePopup});
